import React from "react";
import ContactUsTitle from "../components/ContactUsTitle";
import Form from "../components/Form";

function ContactUs() {
  return (
    <div>
      <ContactUsTitle />
      <Form />
    </div>
  );
}

export default ContactUs;
